// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridItemProps } from "@insite/mobius/GridItem";
import myAccountDetailsStyles from "@vanmeter/App/SharedStyles/MyAccountDetailsStyles";
import xOrderInformationStyles from "@vanmeter/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { orderInformationStyles } from "@vanmeter/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { color, mergeWithCss, avoidBreakInsidePrintElement } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

const gridSharedStyle: GridItemProps = {
    width: [6, 6, 6, 4, 4],
    css: css`
        flex-direction: column;
        gap: 8px;
        @media print {
            display: inline-block;
            width: 25%;
            vertical-align: top;
        }
    `,
};

orderInformationStyles.orderInformationGridContainer = {
    gap: 0,
    offsetCss: css`
        gap: 24px;
    `,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            margin-bottom: 24px;
        }
    `,
};

orderInformationStyles.mainInformationGridContainer = {
    gap: 16,
    css: css`
        @media print {
            display: block;
            ${avoidBreakInsidePrintElement}
        }
    `,
};

orderInformationStyles.mainInformationGridItem = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        &&& {
            padding-bottom: 24px;
            @media print {
                margin-bottom: 24px;
                border-bottom: none;
                padding-bottom: 0;
            }
        }
    `,
};

orderInformationStyles.orderNumberTitle = {
    ...xOrderInformationStyles.infoLabel,
};

orderInformationStyles.orderDateTitle = {
    ...xOrderInformationStyles.infoLabel,
};

orderInformationStyles.poNumberTitle = {
    ...xOrderInformationStyles.infoLabel,
};

orderInformationStyles.statusTitle = {
    ...xOrderInformationStyles.infoLabel,
};

orderInformationStyles.orderNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderDateText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.poNumberText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.statusText = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.orderDateGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.poNumberGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.statusGridItem = {
    ...gridSharedStyle,
};

orderInformationStyles.notesGridItem = {
    ...gridSharedStyle,
    width: 12,
};

orderInformationStyles.notesTitle = {
    ...xOrderInformationStyles.infoLabel,
};

orderInformationStyles.notesDescription = {
    ...xOrderInformationStyles.value,
};

orderInformationStyles.orderApprovalDetailsShippingInformation = {
    shippingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    shippingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    shippingInformationCarrierGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationDateRequestedGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingInformationServiceGridItem: {
        ...gridSharedStyle,
        width: 12,
    },
    shippingCarrierTitle: {
        ...xOrderInformationStyles.infoLabel,
    },
    shippingCarrierText: {
        ...xOrderInformationStyles.value,
    },
    shippingDateRequestedTitle: {
        ...xOrderInformationStyles.infoLabel,
    },
    shippingDateRequestedText: {
        ...xOrderInformationStyles.value,
    },
    shippingServiceTitle: {
        ...xOrderInformationStyles.infoLabel,
    },
    shippingServiceText: {
        ...xOrderInformationStyles.value,
    },
    shippingInformationGridContainer: {
        gap: 0,
    },
    shippingOtherInformationGridContainer: {
        gap: 0,
    },
    shippingInformationAddressGridItem: {
        width: [12, 6, 6, 6, 6],
        css: css`
            flex-direction: column;
        `,
    },
    shippingOtherInformationGridItem: {
        width: [12, 6, 6, 6, 6],
    },
};

orderInformationStyles.orderApprovalDetailsBillingInformation = {
    billingInformationGridContainer: {
        gap: 0,
    },
    billingInformationTitle: {
        ...xOrderInformationStyles.address?.informationTitle,
    },
    billingAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
    billingCreditCardAddressTitle: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            as: "h3",
            css: css`
                margin-bottom: 0;
            `,
        }),
    },
};

orderInformationStyles.shippingInformationGridItem = orderInformationStyles.billingInformationGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        @media Print {
            padding-bottom: 24px;
        }
    `,
};

orderInformationStyles.returnToOrderApprovalLink = {
    ...myAccountDetailsStyles.myAccountDetailsActions?.backLink,
};

orderInformationStyles.addressesHeading = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

orderInformationStyles.headingGridItem = {
    width: 12,
    css: css`
        padding-bottom: 0px;
    `,
};
